import { Component, Vue } from 'vue-property-decorator';
import OmnisearchResultsVo from '@/model/vo/search/omnisearch-results-vo';

@Component
export default class OmniSearch extends Vue
{
    private searchTerm = '';
    private results: OmnisearchResultsVo = {
        clients: [],
        techspecs: [],
        jobs: [],
    };

    private searchTimeout: number|null = null;
    private isSearching = false;

    private searchRoutes: string[] = [
        'client-index', 'techspec-index', 'job-index',
    ];

    created()
    {
        if ('search' in this.$route.query)
        {
            this.searchTerm = this.$route.query.search as string;
        }
    }

    /**
     * Returns whether there are results to show
     */

    private get hasResults()
    {
        return this.results.clients.length > 0 || this.results.techspecs.length > 0 || this.results.jobs.length > 0;
    }

    /**
     * Handles search input updates.
     */

    private async onSearchInput()
    {
        if (this.searchTimeout)
        {
            window.clearTimeout(this.searchTimeout);
        }

        if (!this.searchTerm || (!this.searchTerm.match(/\d+/) && this.searchTerm.length < 3))
        {
            this.clearResults();

            return;
        }

        this.isSearching = true;

        this.searchTimeout = window.setTimeout(async() =>
        {
            const results = await this.$serviceContainer.omnisearchService.search(this.searchTerm);

            if (!this.isSearching)
            {
                return;
            }

            this.isSearching = false;
            this.results = Object.assign({}, results);
        }, 250);
    }

    /**
     * Handles searches.
     */

    private onSearch()
    {
        // Clear any search lookup timeouts as a full search has been ran
        if (this.searchTimeout)
        {
            window.clearTimeout(this.searchTimeout);
            this.isSearching = false;
        }

        // If already on a search page, just update the query string
        if (this.$route.name)
        {
            if (this.searchRoutes.includes(this.$route.name))
            {
                const query = Object.assign({}, this.$route.query);
                query.search = this.searchTerm;

                // Remove the page
                if ('page' in query)
                {
                    delete query.page;
                }

                this.$router.replace({ query });
            }

            // Otherwise redirect to the appropriate page
            else if (this.$route.name.startsWith('client-'))
            {
                this.$router.push({
                    name: 'client-index',
                    query: {
                        search: this.searchTerm,
                    },
                });
            }
            else if (this.$route.name.startsWith('techspec-'))
            {
                this.$router.push({
                    name: 'techspec-index',
                    query: {
                        search: this.searchTerm,
                    },
                });
            }
            else if (this.$route.name.startsWith('job-'))
            {
                this.$router.push({
                    name: 'job-index',
                    query: {
                        search: this.searchTerm,
                    },
                });
            }
        }
    }

    /**
     * Handles search clearing.
     */

    private onClearSearch()
    {
        if (this.$route.name && this.searchRoutes.includes(this.$route.name))
        {
            const query = Object.assign({}, this.$route.query);

            // Remove the search term
            if ('search' in query)
            {
                delete query.search;
            }

            // Remove the page
            if ('page' in query)
            {
                delete query.page;
            }

            this.$router.replace({ query });
        }

        this.clearResults();
    }

    /**
     * Clears the search results.
     */

    private clearResults()
    {
        this.results.clients = [];
        this.results.techspecs = [];
        this.results.jobs = [];
    }

    /**
     * Handles result clicks
     */

    private onResultClick()
    {
        this.searchTerm = '';
        this.clearResults();
    }
}